<template>
  <div class="app">
    <!-- nav部分 -->
    <!-- <div class="header" :class="$route.meta&&$route.meta.headerStyle==='white'?'white':''"> -->
    <common-header
    :rootWrapClass="['container']"
    pcMenuStyle='myhover'
    :loginUser="userInfo"
    :menu="menuList"
    :showMenu="isShowNav"
    :pcMenuIsNearLogoInfo="true"
    :logoImage='logoImage'
    :theme="headerStyle.theme"
    :rootPosition="headerStyle.rootPosition"
    :stickyInfo="headerStyle.stickyInfo"
    logoHref="https://tgo.infoq.cn"
    mobileLayoutStyle="scrollY"
    @logout="logout"
    :isMobile="isMobile"
    :tgoUserInfo="baseInfo"
    :showDashboardInfo="!isAdmin"
    v-if="!($route.name==='eventdetail' && Number($route.params.id)===-99) && ($route.meta.isShowHeader === undefined || $route.meta.isShowHeader)"
  >
      <template slot="search">
        <search-PC @searchDisplay="searchDisplay"></search-PC>
      </template>
      <li slot="searchmobile">
        <search-mobile @searchDisplay="searchDisplay"></search-mobile>
      </li>
    </common-header>
    <!-- </div> -->

    <!-- body部分 -->
    <router-view :isMobile="isMobile"></router-view>

    <div :style="{height: `${geoBannerHeight}px`}" v-if="!isInWXMiniProgram && showGeoBanner && geoBannerData">
      <div ref="geoBanner" :data-icon="geoBannerData.markLabel"
        :class="['geo-banner', {fixed: !isBottom}, {'show-corner-mark': geoBannerData.cornerMark}]"
        :style="geoBannerStyle"
      >
        <gkAdEvent class="image" tag="a" :src="geoBannerData.src" :idea="geoBannerData" />
        <div class="close-geo" @click="handleCloseGeoBanner"></div>
      </div>
    </div>

    <!-- footer部分 -->
    <div id="check-bottom-bar" ref="checkBottomBar"></div>
    <tgo-footer v-if="!($route.name==='eventdetail' && Number($route.params.id)===-99) && ($route.meta.isShowFooter === undefined || $route.meta.isShowFooter)"></tgo-footer>

    <GlobalLayer></GlobalLayer>
  </div>
</template>
<script>
import tgoFooter from '@/components/footer'
// import commonHeader from '@geekbang/geek.base/src/components/Header'
import commonHeader from '@/components/header'
import searchMobile from '@/components/header-search/mobile'
import searchPC from '@/components/header-search/pc'
import GlobalLayer from '@/components/common/globalLayer'
import gkAdEvent from 'gkui/ad/ADEvent'

import headerMixin from '@/mixins/header'
// import alert from '@/base/message/index'

import { mapState, mapMutations, mapGetters } from 'vuex'
import AccountService from '@/service/account.service.js'
import InfoQService from '@/service/infoq.service.js'
import TGOService from '@/service'
import util from './util'
import cookie from './util/cookie'

export default {
  name: 'app',
  mixins: [headerMixin],
  data () {
    return {
      isShowNav: true,
      isMobile: true,
      isIOS: false,
      logoImage: {
        black: require('./assets/logo_black.png'),
        white: require('./assets/logo_white.png')
      },
      hideGeoBanner: false,
      geoBannerHeight: 0,
      geoBannerData: undefined
    }
  },
  components: {
    tgoFooter,
    commonHeader,
    searchPC,
    searchMobile,
    GlobalLayer,
    gkAdEvent
  },
  created () {
    // 跨域
    // window.document.domain = 'geekbang.org'

    // 获取设备宽度
    this.getWindowWidth()

    // 登录相关
    this.getLoginInfo()

    // 学员信息相关
    this.getVIPStatus()

    // 获取tgo用户信息（第一表单）
    this.getTGOUserInfo()

    // 获取 geobanner
    this.getGeoBanner()
  },
  methods: {
    // 注册点击事件
    ...mapMutations({
      setMobileInfo: 'CHECK_MOBILE',
      setPCInfo: 'CHECK_PC',
      setLoginInfo: 'LOGIN',
      setUserInfo: 'USER_INFO',
      setApplyStatusInfo: 'APPLY_STATUS_INFO',
      setBaseInfo: 'SET_BASE_INFO',
      setBottom: 'CHECK_BOTTOM'
    }),

    searchDisplay () {
      this.isShowNav = !this.isShowNav
    },

    getWindowWidth () {
      let winWidth = 0
      if (window.innerWidth) {
        winWidth = window.innerWidth
      } else if ((document.body) && (document.body.clientWidth)) {
        winWidth = document.body.clientWidth
      }
      this.isMobile = winWidth < 768
      this.setMobileInfo(this.isMobile)
    },

    // 移动端固定布局
    mobileLayout () {
      let app = document.querySelector('.app')
      let body = app.parentNode
      let html = body.parentNode
      if (this.isMobile) {
        app.classList.add('app-fix')
        body.classList.add('dropdown-fix')
        html.classList.add('dropdown-fix')
      }
    },

    /**
     * 获取登录信息
     */
    getLoginInfo () {
      AccountService.getLoginInfo()
        .then((res) => {
          this.setLoginInfo(true)
          this.setUserInfo(res)
        })
        .catch((e) => {
          console.log(e)
          this.setLoginInfo(false)
          this.setUserInfo({})
        })
    },

    /**
     * 获取用户是否是学员
     */
    getVIPStatus () {
      TGOService.getUserStatus()
        .then(res => {
          this.setApplyStatusInfo(res)
        })
        .catch(err => console.log(err))
    },

    getTGOUserInfo () {
      TGOService.getUserInfo()
        .then(res => {
          if (Array.isArray(res) && !res.length) {
            res = {}
          }
          this.setBaseInfo(res)
        })
        .catch(err => console.log(err))
    },

    logout () {
      AccountService.logout().then(() => {
        // this.setUserInfo({})
        window.location.reload()
      })
    },

    getGeoBanner () {
      if (this.$route.name === 'notFound') {
        return
      }

      InfoQService.getGeoBanner().then(ad => {
        this.geoBannerData = ad
      })
    },

    /**
     * 关闭 geo banner
     */
    handleCloseGeoBanner () {
      this.hideGeoBanner = true
      cookie.set('tgeo', this.nowTime)
    },

    /**
     * 监听 scroll
     * 判断是否已到底部
     */
    listenerScroll (event) {
      const footCom = this.$refs.checkBottomBar
      this.setBottom(footCom && footCom.getBoundingClientRect().top <= window.innerHeight)
    }
  },
  computed: {
    ...mapState([
      'userInfo',
      'baseInfo',
      'isBottom',
      'nowTime'
    ]),
    ...mapGetters([
      'showVIPSections',
      'isAdmin'
    ]),
    menuList () {
      let arr = [
        {
          id: 1,
          link: '',
          name: '学员展示',
          subMenu: [
            { link: '/we/branches', subName: '董事会成员' }
          ]
        },
        { id: 2, link: '/event', name: '学习活动' },
        { id: 6, link: '/biz-atlas', name: '企业图谱' },
        { id: 3, link: '/notice', name: '公告新闻' },
        { id: 4, link: '/join', name: '申请加入' },
        {
          id: 5,
          link: '',
          name: '关于 TGO 鲲鹏会',
          subMenu: [
            { link: '/about/global', subName: '关于 TGO 全球' },
            { link: '/about/use', subName: '使用条款' },
            { link: '/about/privacy', subName: '隐私条款' },
            { link: '/about/FAQ', subName: '常见问题' }
          ]
        },
        // { id: 6, link: '/trainingshare', name: '梁宁巡回演讲' }
        // { id: 6, link: '/lecturetour', name: '马蒂·卡根分享' }
        // { id: 7, link: 'https://gtlc.infoq.cn/2025/chengdu', name: 'GTLC 成都站' }
        { id: 7, link: 'https://gtlc.infoq.cn/2025/guangzhou', name: 'GTLC 大湾区站' }
      ]

      // 会员或者员工
      if (this.showVIPSections) {
        let membersMenu = arr.find(item => item.id === 1)
        let aboutMenu = arr.find(item => item.id === 5)
        let noticeMenuIdx = arr.findIndex(item => item.id === 3) + 1

        membersMenu.subMenu.unshift({ link: '/we/members', subName: '全球学员名单' })
        aboutMenu.subMenu.unshift({ link: '/about/finance', subName: 'TGO 运营情况' })

        arr.splice(noticeMenuIdx, 0, {
          link: '',
          name: '学员培训',
          subMenu: [
            { link: '/training/chart', subName: '培训章程' },
            { link: '/training/teachers', subName: '培训师' }
          ]
        })
      }

      // if (this.$route.meta.auth && this.userInfo.nick) {
      //   arr.forEach((item, index) => {
      //     if (item.link === this.$route.meta.path) {
      //       item.hideNav = false
      //     }
      //     if (item.subMenu) {
      //       item.subMenu.forEach((each, idx) => {
      //         if (each.link === this.$route.meta.path) {
      //           item.hideNav = false
      //         }
      //       })
      //     }
      //   })
      // }
      // if (this.$route.meta.vip) {}
      return arr
    },
    isInWXMiniProgram () {
      return util.isInWXMiniProgram()
    },
    geoClosed () {
      const closeTime = cookie.get('tgeo')

      return closeTime > 0 && new Date(closeTime).getDate() === new Date(this.nowTime).getDate()
    },
    showGeoBanner () {
      // 路由 加了 hideGeoBanner 参数，有这个参数的页面不显示 banner
      return !this.geoClosed && !this.hideGeoBanner && !this.$route.meta.hideGeoBanner
    },
    geoBannerStyle () {
      if (this.geoBannerData) {
        return {
          backgroundImage: `url(${this.isMobile ? this.geoBannerData.extra.content_mobile_bg : this.geoBannerData.extra.content_pc_bg})`
        }
      }

      return {}
    }
  },
  mounted () {
    // 相关事件的开启
    // this.mobileLayout()

    window.onresize = () => { this.getWindowWidth() }
    window.addEventListener('scroll', this.listenerScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  },
  watch: {
    geoBannerData (newGeo) {
      this.$nextTick(() => {
        const geoCom = this.$refs.geoBanner
        this.geoBannerHeight = geoCom && (geoCom.getBoundingClientRect().height || 0)
        const style = document.createElement('style')
        document.head.appendChild(style)
        const sheet = style.sheet
        sheet.insertRule(`.close-geo:before {background-color: #${newGeo.extra.close_color}!important;}`)
        sheet.insertRule(`.close-geo:after {background-color: #${newGeo.extra.close_color}!important;}`)
      })
    }
  }
}
</script>

<style lang="sass">
@import "./style/bulma/init.sass"
@import "./style/bulma/app.sass"
@import "./style/icon/iconfont.css"
@import "./style/custom/club.header.scss"
@import "./style/animation.scss"
@import './style/custom.message'
@import './style/custom.loading'
// @import '~iview/dist/styles/iview.css'
// @import './style/iview/iview.css'

html,body
  -webkit-tap-highlight-color: rgba(0,0,0,0)

// .app
//   .header
//     position: absolute
//     width: 100%
//     z-index: 100
//     top: 0
//     &.white
//       position: initial

//   .common-header .common-header-wrapper
//     width: 1080px
//     text-align: center
// +mobile
//   .app
//     display: flex
//     flex-direction: column
//     .header
//       width: 100%
//       flex-shrink: 0
//       .common-header .common-header-wrapper
//         width: 96vw

</style>

<style lang="scss">
@import './style/bulma/app.sass';

.geo-banner {
  position: relative;
  width: 100%; height: 115px;
  // background: rgba(194, 58, 44, 0.9);
  // background: url('../../assets/img/geo/2019-12-10-pc-bg.png') center no-repeat;
  background-size: auto 115px;

  &.show-corner-mark {
    position: relative;
    @include themeIcon(5px, 5px, 1);
    &:before {
      left: 50%;
      margin-left: -535px;
    }
  }

  &.fixed {
    position: fixed; left: 0; bottom: 0; right: 0; z-index: 10000;
  }

  & .image {

    & img {
      display: block;
      width: 1080px; height: 100%;
      margin: 0 auto;
    }

  }

  // & img {
  //   display: block;
  //   width: 1080px; height: 100%;
  //   margin: 0 auto;
  // }

  & .close-geo {
    position: absolute; left: 50%; top: 0;
    width: 40px; height: 52px;
    margin-left: 540px;
    cursor: pointer;

    &:before,
    &:after {
      content: ' ';
      display: block;
      position: absolute; left: 9px; top: 25px;
      width: 21px; height: 1px;
      background: #FFF;
      // background: #ECC39C;
      transform-origin: center;
    }

    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
}

@include mobile {
  .geo-banner {
    height: 90px;
    // background: rgba(15, 73, 156, 0.87);
    // background-image: url('../../assets/img/geo/2019-12-10-wap-bg.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    & .image {

      & img {
        width: 100%; height: 100%;
      }
    }

    & .close-geo {
      position: absolute; left: auto; right: 0;
      width: 30px; height: 30px;
      margin-left: 0;

      &:before,
      &:after {
        position: absolute; left: 7px; top: 15px;
        width: 16px; height: 1px;
      }
    }
  }
}

@media screen and (max-width: 360px) {
  .geo-banner {
    height: 86px;
  }
}
@media screen and (max-width: 320px) {
  .geo-banner {
    height: 75px;
  }
}
</style>
